import type { EnumUnion } from '@dresscode-frontend/utility-types';

import type {
  ValueLayer,
  ValueListItem,
  ValueType,
} from '@/features/stacktrace/product-central/values/-query/type';

/**
 * 価値（Value）一覧のテーブル列ID。
 *
 * 表示順:
 *   No / タイトル / 起票者 / 種別 / レイヤー / 誰の / どの業務 /
 *   課題 / 定量的な負のインパクト / 原因(定性) / 理想像 / 価値(効果)
 *
 * 「方法」（methodCount）は別画面（詳細など）で扱う想定のため一覧には出さない。
 */
export const ValueTableColumns = {
  CODE: 'CODE',
  TITLE: 'TITLE',
  REPORTER: 'REPORTER',
  VALUE_TYPE: 'VALUE_TYPE',
  VALUE_TYPE_LABEL: 'VALUE_TYPE_LABEL',
  LAYER: 'LAYER',
  TARGET_USER: 'TARGET_USER',
  TARGET_BUSINESS: 'TARGET_BUSINESS',
  ISSUE: 'ISSUE',
  QUANTITATIVE_NEGATIVE_IMPACT: 'QUANTITATIVE_NEGATIVE_IMPACT',
  CAUSE_QUALITATIVE: 'CAUSE_QUALITATIVE',
  IDEAL_STATE: 'IDEAL_STATE',
  VALUE_EFFECT: 'VALUE_EFFECT',
} as const;
export type ValueTableColumns = EnumUnion<typeof ValueTableColumns>;

type ValueTitleColumn = {
  id: string;
  title: string;
};

type ValueReporterColumn = {
  personId: string;
  name: string | null;
};

export type ValueTableRowData = {
  [ValueTableColumns.CODE]: string;
  [ValueTableColumns.TITLE]: ValueTitleColumn;
  [ValueTableColumns.REPORTER]: ValueReporterColumn;
  [ValueTableColumns.VALUE_TYPE]: ValueType | undefined;
  [ValueTableColumns.VALUE_TYPE_LABEL]: string | undefined;
  [ValueTableColumns.LAYER]: ValueLayer | undefined;
  [ValueTableColumns.TARGET_USER]: string;
  [ValueTableColumns.TARGET_BUSINESS]: string;
  [ValueTableColumns.ISSUE]: string;
  [ValueTableColumns.QUANTITATIVE_NEGATIVE_IMPACT]: string;
  [ValueTableColumns.CAUSE_QUALITATIVE]: string;
  [ValueTableColumns.IDEAL_STATE]: string;
  [ValueTableColumns.VALUE_EFFECT]: string;
};

export const convertValueItemToTableRow = (
  item: ValueListItem,
): ValueTableRowData => {
  return {
    [ValueTableColumns.CODE]: item.code,
    [ValueTableColumns.TITLE]: { id: item.id, title: item.title },
    [ValueTableColumns.REPORTER]: {
      personId: item.reporterPersonId,
      name: item.reporterPersonName,
    },
    // BE は status を返すが、UI 命名規約に合わせて valueType に詰め替える
    [ValueTableColumns.VALUE_TYPE]: item.status as ValueType | undefined,
    [ValueTableColumns.VALUE_TYPE_LABEL]: undefined,
    [ValueTableColumns.LAYER]: item.layer as ValueLayer | undefined,
    [ValueTableColumns.TARGET_USER]: item.targetUser,
    [ValueTableColumns.TARGET_BUSINESS]: item.targetBusiness,
    [ValueTableColumns.ISSUE]: item.issue,
    [ValueTableColumns.QUANTITATIVE_NEGATIVE_IMPACT]:
      item.quantitativeNegativeImpact,
    [ValueTableColumns.CAUSE_QUALITATIVE]: item.causeQualitative,
    [ValueTableColumns.IDEAL_STATE]: item.idealState,
    [ValueTableColumns.VALUE_EFFECT]: item.valueEffect,
  };
};
